export type ServiceResult<T> = ServiceSuccess<T> | ServiceError;
export interface ServiceSuccess<T> {
  data: T;
}
export interface ServiceError {
  errors: string[];
}
export function isServiceError(object: unknown): object is ServiceError {
  return object !== undefined && Object.prototype.hasOwnProperty.call(object, 'errors');
}
export function isServiceSuccess<T>(object: unknown): object is ServiceSuccess<T> {
  return object !== undefined && Object.prototype.hasOwnProperty.call(object, 'data');
}
export function isServiceResult<T>(object: unknown): object is ServiceResult<T> {
  return isServiceSuccess(object) || isServiceError(object);
}
